import purchaseOrder from './purchase-order'
import purchaseRequisition from './purchase-requisition'
import supplier from './supplier'

export default {
  namespaced: true,
  modules: { purchaseOrder, purchaseRequisition, supplier },
}
